import type { AgendaScenarioViewConfig } from '../store/agendaStore';
import { addDatapointConfig } from 'owa-analytics-actions';
import { action } from 'satcheljs';
import type { OwaDate } from 'owa-datetime';
import type { QuickAddViewState } from 'owa-todo-views';
import type { ActionSource } from 'owa-todo-types';
import type { QuickComposeEntrySourceType } from 'owa-calendar-helpers-types/lib/ComposeMetricTypes';
import { CalendarEventsFilters } from 'owa-calendar-events-filter';

export const updateTopOfListIndex = action(
    'updateTopOfListIndex ',
    (topOfListIndex: number, scenarioId: string) => ({
        topOfListIndex,
        scenarioId,
    })
);

export const updateCurrentEditingTodoId = action(
    'updateCurrentEditingTodoId ',
    (todoId: string, isEditing: boolean, scenarioId: string) => ({
        todoId,
        isEditing,
        scenarioId,
    })
);

export const hideTodoContextMenu = action('hideTodoContextMenu', (scenarioId: string) => ({
    scenarioId,
}));

export const scrollToUpNext = action('scrollToUpNext', (scenarioId: string) => ({
    scenarioId,
}));

export const scrollToDateHeader = action(
    'scrollToDateHeader',
    (date: OwaDate, scenarioId: string) => ({
        date,
        scenarioId,
    })
);

export const restoreSavedScrollPosition = action(
    'restoreSavedScrollPosition',
    (scenarioId: string) => ({
        scenarioId,
    })
);

export const scrollToTop = action('scrollToTop', (scenarioId: string) => ({
    scenarioId,
}));

export const updateShouldAutoScroll = action(
    'updateShouldAutoScroll',
    (shouldAutoScroll: boolean, scenarioId: string) => ({ shouldAutoScroll, scenarioId })
);

export const initializeScenario = action(
    'initializeScenario',
    (
        selectedDate: OwaDate,
        scenarioId: string,
        shouldShowTasks: boolean,
        todoActionSource: ActionSource,
        shouldShowDeclinedEvents: boolean,
        viewConfig: AgendaScenarioViewConfig,
        entrySource: QuickComposeEntrySourceType,
        currentFilters: (CalendarEventsFilters | string)[]
    ) => ({
        selectedDate,
        scenarioId,
        shouldShowTasks,
        todoActionSource,
        shouldShowDeclinedEvents,
        viewConfig,
        entrySource,
        currentFilters,
    })
);

export const onLoadMoreItems = action('onLoadMoreItems', (scenarioId: string) =>
    addDatapointConfig(
        {
            name: 'agendaEventsActionLoadMoreItems',
            customData: { scenarioId },
        },
        {
            scenarioId,
        }
    )
);

export const handleLoadLimitReached = action('handleLoadLimitReached', (scenarioId: string) =>
    addDatapointConfig(
        {
            name: 'agendaEventsActionLoadLimitReached',
            customData: { scenarioId },
        },
        {
            scenarioId,
        }
    )
);

export const updateQuickAddViewState = action(
    'updateQuickAddViewState',
    (scenarioId: string, quickAddViewState: Partial<QuickAddViewState>) => ({
        scenarioId,
        quickAddViewState,
    })
);
